export async function handleFusedeckSubmitDatalayer() {
    try {
        window.fdData = window.fdData || [];
        window.fdData.push({ conversion: 'lead_launch' });
    } catch (e) {
        console.log('fdData error:', e);
    }
}
